module.exports = __webpack_public_path__ + "components/flag/static/square/lt-bee816119c3940381718286b3190ea22.svg";